import { z } from "zod";
import { TERM, DAYS } from "../consts";

export const schema = z.object({
  [TERM]: z.string().optional(),
  [DAYS]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
